export const VOICE_LIVE_CALL_UPSERT = 'VOICE_LIVE_CALL_UPSERT';
export const VOICE_LIVE_CALL_MARK_ANSWERED = 'VOICE_LIVE_CALL_MARK_ANSWERED';
export const VOICE_LIVE_CALL_END = 'VOICE_LIVE_CALL_END';
export const VOICE_LIVE_CALL_PURGE = 'VOICE_LIVE_CALL_PURGE';
export const VOICE_LIVE_CALLS_SET_SNAPSHOT = 'VOICE_LIVE_CALLS_SET_SNAPSHOT';
export const VOICE_LIVE_CALLS_CLEAR = 'VOICE_LIVE_CALLS_CLEAR';

/**
 * @param {object} partial Live call entry fragment (camelCase or snake_case), requires callControlId.
 */
export const voiceLiveCallUpsert = (partial) => ({
  type: VOICE_LIVE_CALL_UPSERT,
  payload: partial
});

/**
 * @param {{ callControlId: string, answeredAt?: string, answeredByUserId?: string|number|null }} payload
 */
export const voiceLiveCallMarkAnswered = (payload) => ({
  type: VOICE_LIVE_CALL_MARK_ANSWERED,
  payload
});

/**
 * @param {{ callControlId: string, endedAt?: string }} payload
 */
export const voiceLiveCallEnd = (payload) => ({
  type: VOICE_LIVE_CALL_END,
  payload
});

/**
 * @param {string} callControlId
 */
export const voiceLiveCallPurge = (callControlId) => ({
  type: VOICE_LIVE_CALL_PURGE,
  payload: callControlId
});

/**
 * @param {unknown} snapshot Raw `/voice/calls/active` response ({ serverTime, calls }) or array.
 */
export const voiceLiveCallsSetSnapshot = (snapshot) => ({
  type: VOICE_LIVE_CALLS_SET_SNAPSHOT,
  payload: snapshot
});

export const voiceLiveCallsClear = () => ({
  type: VOICE_LIVE_CALLS_CLEAR
});
